import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GroupInput } from '../../../../components/GroupInput/GroupInput';
import { START_TO_TYPE } from '../consts';
import { getServiceOptions, getServiceSelected } from '../../../store/selectors';
import { selectService, setBookingError, setPreselectedData } from '../../../store/serviceSlice';

export const ServicesSelector = ({ onSelect }) => {
    const { services: selected = '' } = useSelector(getServiceSelected);
    const data = useSelector(getServiceOptions);
    const dispatch = useDispatch();

    const getMetadata = useCallback(() => {
        return data.map((item) => {
            const id = (item?.id ? item.id : item?.name);
            const code = (item?.code ? item?.code : item?.name);
            return {
                ...item,
                id,
                code,
            };
        });
    }, [data]);

    const onChangeHandler = (value) => {
        dispatch(setBookingError(''));
        dispatch(setPreselectedData({
            branches: null,
            doctors: null,
            services: null,
        }));
        if (onSelect) {
            if (onSelect(value)) {
                dispatch(selectService(value));
            }
        } else {
            dispatch(selectService(value));
        }
    };
    return <>
        <GroupInput
            type="selector"
            label="Услуга"
            placeholder={START_TO_TYPE}
            value={selected}
            onChange={onChangeHandler}
            metaData={getMetadata()}
            onClear={() => onChangeHandler('')}
            id="service"
        />
    </>;
};
